import request from '../axios';
import {IPatchQrCodeBody} from './orderQrCode.types';

export async function getQRCode({advertisementId}: {advertisementId: string}) {
  const url = `/api/v2/store/advertisement-link/${advertisementId}`;
  const {data} = await request.get(url);
  return data;
}

export async function updateQRCode(qrCodeData: IPatchQrCodeBody) {
  const postData = {
    advertisements: [qrCodeData],
  };
  const url = '/api/v2/store/bulk-advertisements-link';
  const {data} = await request.patch(url, postData);
  return data;
}

export async function deleteQrCode({
  advertisementId,
}: {
  advertisementId: string;
}) {
  const url = `/api/v2/store/advertisement-link/${advertisementId}`;
  const {data} = await request.delete(url);
  return data;
}
